import React from 'react'
import dt from 'dayjs'

type IUiDateInfo = {
	value: Date | string | null // Date ISO in UTC,
	styles?: React.CSSProperties
	showDateLong?: boolean
}
export const UiDateInfo = ({
	value,
	styles = {},
	showDateLong = false
}: IUiDateInfo) => {
	const date: Date | null = value ? dt.utc(value).toDate() : null
	const dateLong: string = date ? dt.utc(date).format('DD.MM.YYYY HH:mm:ss') : ''
	const dateShort: string = date ? dt.utc(date).format('DD.MM.YYYY') : ''

	return <div style={styles} {...(!showDateLong && { title: dateLong })}>{showDateLong ? dateLong : dateShort}</div>
}